import { QueryCache, QueryClient } from "@tanstack/react-query";
import { ApiError } from "./lib/api";

let onUnauthorized: () => void = () => {};

export function setUnauthorizedHandler(fn: () => void) {
  onUnauthorized = fn;
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (err) => {
      if (err instanceof ApiError && err.isUnauthorized) onUnauthorized();
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 10_000,
      retry: (count, err) => !(err instanceof ApiError && (err.isUnauthorized || err.status === 403)) && count < 2,
      refetchOnWindowFocus: true,
    },
  },
});
